import { restApi } from '../../../services/api';
import {
  Chat,
  ChatUser,
  CreateChatDto,
  CreatedMessageResponse,
  GetChatToUpdate,
  UpdateChatData,
  VideoCall,
} from '../types/chat.types';

const chatRepository = {
  createChat: (data: CreateChatDto) => restApi.post<Chat>('chats', data),
  updateChat: (data: UpdateChatData, chatId: string) => restApi.put<Chat>(`chats/${chatId}`, data),
  getChatToUpdate: (chatId: string) => restApi.get<GetChatToUpdate>(`chats/${chatId}/to-update`),
  getById: (chatId: string) => restApi.get<Chat>(`chats/${chatId}`),
  getChatUsersParticipants: (chatId: string) =>
    restApi.get<{ data: ChatUser[] }>(
      `chats/${chatId}/users-participants?order[name]=ASC&order[surname]=ASC`,
    ),
  getPrivateChatAndCreateIfNotFound: (dto: { brandId?: string; storeId?: string }) =>
    restApi.post<Chat>('chats/private', dto),

  getVideoCallByChatId: (chatId: string) => restApi.get<VideoCall>(`chats/${chatId}/video-call`),
  createVideoCall: (chatId: string) =>
    restApi.post<CreatedMessageResponse>(`chats/${chatId}/video-call`),
  deleteVideoCall: (chatId: string) =>
    restApi.delete<CreatedMessageResponse>(`chats/${chatId}/video-call`),
};

export default chatRepository;
